module.exports = __webpack_public_path__ + "static/img/4-2.b2a79a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4-2.jpg
// module id = YjcG
// module chunks = 0